import { PortModelAlignment } from '@projectstorm/react-diagrams';
import NodeTypes from '../../NodeTypes';
import DefaultNodeModel, { DefaultNodeModelOptions } from '../defaultNode/DefaultNodeModel';
import { PortModel } from '../../ports/PortModel';

export interface UserIntentNodeModelOptions extends DefaultNodeModelOptions {
}

export class UserIntentNodeModelData {
	intentId: number | undefined
}

export default class UserIntentNodeModel extends DefaultNodeModel {
	data: UserIntentNodeModelData = new UserIntentNodeModelData();

	constructor(options: UserIntentNodeModelOptions = {}) {
	  super({
	    ...options,
	    type: NodeTypes.userIntentNode,
	  });
	  // setup an in and out port
	  this.addPort(
	    new PortModel({
	      in: true,
	      name: 'in',
	      alignment: PortModelAlignment.BOTTOM,
	    }),
	  );
	  this.addPort(
	    new PortModel({
	      in: false,
	      name: 'out',
	      alignment: PortModelAlignment.TOP,
	    }),
	  );
	}

	public setTitle(title: string) {
	  this.title = title;
	}

	serialize() {
	  return {
	    ...super.serialize(),
	  };
	}

	deserialize(event:any): void {
	  super.deserialize(event);
	}
}
